import L from 'leaflet'
import { ref } from '@vue/composition-api'

export default function Player(points, marker, map) {

  const isPlaying = ref(false)
  const defaultSpeed = ref('x3')


  let intervalId = 0
  let moveStepId = 0

  const currentDelaySpeed = ref(1000)
  const currentDelayDelta = ref(10)
  const currentNumDelta = ref(100)


  /**
   *
   * @param delaySpeed
   * @param delayDelta
   * @param numDeltas
   */
  const changeValue = (delaySpeed, delayDelta, numDeltas) => {
    currentDelaySpeed.value = delaySpeed
    currentDelayDelta.value = delayDelta
    currentNumDelta.value = numDeltas
  }


  const changeSpeed = () => {
    switch (defaultSpeed.value) {
      case 'x1': return changeValue(5000, 50, 100)
      case 'x2': return changeValue(3000, 30, 100)
      case 'x4': return changeValue(80, 1, 80)
      case 'x5': return changeValue(40, 1, 40)
      case 'x6': return changeValue(20, 1, 20)
      default: changeValue(2000, 10, 200)
    }
  }

  const pause = () => {
    isPlaying.value = false
    clearInterval(intervalId)
  }


  const decreaseSpeed = () => {
    pause()
    if (defaultSpeed.value.slice(1,2) > 1)
      defaultSpeed.value = 'x'+ (parseInt(defaultSpeed.value.slice(1,2)) - 1)
    changeSpeed()
    move()
  }


  const move = () => {

    isPlaying.value = true
    intervalId = setInterval(() => {

      if (moveStepId === points.value.points.length - 1) {
        clearInterval(intervalId)
        playAgain()
      }

      marker.value.setLatLng([points.value.points[moveStepId].latitude, points.value.points[moveStepId].longitude])
      marker.value.setIcon(getMarkerIcon(points.value.points[moveStepId]))
      map.value.panTo([points.value.points[moveStepId].latitude, points.value.points[moveStepId].longitude])

      moveStepId++
    }, currentDelaySpeed.value)
  }



  const playAgain = () => {
    isPlaying.value = false
    moveStepId = 0
    intervalId = 0
  }


  const increaseSpeed = () => {
    pause()
    if (defaultSpeed.value.slice(1,2) < 6) {
      defaultSpeed.value = 'x'+ (parseInt(defaultSpeed.value.slice(1,2)) + 1)
    }
    changeSpeed()
    move()
  }


  let icons = []

  const getMarkerIcon = (p) => {

    if (!icons.includes(p.status)) {

      let img;

      try {
        img = require('@/assets/markers/'+p.category+'/'+p.status+'.svg')
      } catch (e) {
        img = require('@/assets/markers/'+p.status+'.svg')
      }

      icons[p.status] = img
    }

    return L.divIcon({
      html: L.Util.template(`<div class="rotate-${p.course}"><img src="${icons[p.status]}" alt=""></div>`),
      iconSize    : [30, 40],
    })
  }


  return {
    move,
    increaseSpeed,
    decreaseSpeed,
    pause,
    isPlaying,
    defaultSpeed
  }
}
